import { render, staticRenderFns } from "./xlSecretManage.vue?vue&type=template&id=035be4d0&"
import script from "./xlSecretManage.vue?vue&type=script&lang=js&"
export * from "./xlSecretManage.vue?vue&type=script&lang=js&"
import style0 from "./xlSecretManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports